import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollRestoration() {
  const { pathname } = useLocation();
  const navType = useNavigationType(); // "PUSH" | "POP" | "REPLACE"

  const lastPathRef = useRef(pathname);
  const isNavigatingRef = useRef(false);
  const navResetTimerRef = useRef(null);

  // 🛡️ Marchează începutul navigării (oprește salvările scrollului)
  const startNavigating = () => {
    if (isNavigatingRef.current) return;
    isNavigatingRef.current = true;

    // fallback: dacă clickul nu duce la navigare reală
    if (navResetTimerRef.current) clearTimeout(navResetTimerRef.current);
    const currentPath = lastPathRef.current;
    navResetTimerRef.current = setTimeout(() => {
      if (lastPathRef.current === currentPath) {
        isNavigatingRef.current = false;
      }
    }, 500);
  };

  // 💾 Salvează scrollul paginii anterioare la începutul navigării
  useEffect(() => {
    const saveBeforeNav = () => {
      if (isNavigatingRef.current) return;
      const prevPath = lastPathRef.current;
      const y = window.scrollY;
      sessionStorage.setItem(`scroll-${prevPath}`, y.toString());
      startNavigating();
    };

    // ascultăm clickuri (înainte de router) + navigări prin butoane browser
    document.addEventListener("click", saveBeforeNav, true);
    window.addEventListener("popstate", saveBeforeNav);

    return () => {
      document.removeEventListener("click", saveBeforeNav, true);
      window.removeEventListener("popstate", saveBeforeNav);
    };
  }, []);

  // 📥 Restaurare scroll la mount-ul rutei noi
  useEffect(() => {
    const saved = sessionStorage.getItem(`scroll-${pathname}`);
    const target = navType === "POP" && saved ? parseInt(saved, 10) : 0;

 
    const t = setTimeout(() => {
      window.scrollTo(0, target);

      // Navigarea s-a terminat → deblocăm salvările
      isNavigatingRef.current = false;
      if (navResetTimerRef.current) {
        clearTimeout(navResetTimerRef.current);
        navResetTimerRef.current = null;
      }

      lastPathRef.current = pathname;
    }, 120);

    return () => clearTimeout(t);
  }, [pathname, navType]);

  // 💾 Salvare throttled în timpul scrollului (dacă nu navigăm)
  useEffect(() => {
    let timeout;
    const handleScroll = () => {
      if (isNavigatingRef.current) {
        return;
      }
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const y = window.scrollY;
        sessionStorage.setItem(`scroll-${pathname}`, y.toString());
        }, 350);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pathname]);

  return null;
}
